var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596266",
    d: "M7.5,15 C3.35786438,15 1.33226763e-14,11.6421356 1.33226763e-14,7.5 C1.33226763e-14,3.35786438 3.35786438,1.77635684e-15 7.5,1.77635684e-15 C11.6421356,1.77635684e-15 15,3.35786438 15,7.5 C15,8.53287447 14.79121,9.51698344 14.4135335,10.4124235 L15,15 L11.0822429,14.090821 C10.0178224,14.6705801 8.79738129,15 7.5,15 Z M13.3874457,10.2720142 L13.4921372,10.0237992 C13.8258589,9.23257234 14,8.37933025 14,7.5 C14,3.91014913 11.0898509,1 7.5,1 C3.91014913,1 1,3.91014913 1,7.5 C1,11.0898509 3.91014913,14 7.5,14 C8.60076975,14 9.65977513,13.7268855 10.603921,13.2126364 L10.9378717,13.0307431 L13.8257916,13.7009316 L13.3874457,10.2720142 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramComment);
export default __webpack_public_path__ + "static/media/InstagramComment.501b1653.svg";
export { ForwardRef as ReactComponent };